import * as Icons from "@mui/icons-material";

export default function IconText({ icon, sx, ...props }) {
  var Icon = Icons[icon];
  Icon = Icon ?? Icons["Storage"];
  return <Icon sx={sx} {...props} />;
}
